/***************************************************************************************************
 * LOCALIZE – MUST BE FIRST
 */
import '@angular/localize/init';

/***************************************************************************************************
 * Browser polyfills
 */
import 'url-search-params-polyfill';
import 'core-js/modules/es.array.includes';

/***************************************************************************************************
 * Zone JS is loaded via project.json polyfills array for proper Angular builder integration.
 */
